import { Statistic as AntStatistic } from 'antd';
import type { ReactNode } from 'react';
import React from 'react';
import CountUp from 'react-countup';
import styled from 'styled-components';

const Stat = styled(AntStatistic)`
  display: flex;
  flex-direction: column-reverse;

  .ant-statistic-content-value,
  .ant-typography {
    color: ${({ theme }) => theme.primaryColor};
  }
`;

interface StatisticProps {
  loading: boolean;
  title: string;
  value?: number;
  decimals?: number;
  suffix?: ReactNode;
}

const Statistic = function ({
  loading,
  title,
  value = 0,
  decimals,
  suffix,
}: StatisticProps) {
  const formatter = () => <CountUp end={value} decimals={decimals} />;

  return (
    <Stat
      loading={loading}
      title={title}
      value={value}
      suffix={suffix}
      formatter={formatter}
      styles={{ content: { fontWeight: 500 } }}
    />
  );
};

export default Statistic;
